<app-hero
	[title]="'hero.auctions' | translate"
	subtitle=""
	[imageDesktop]="market ? 'assets/hero/HP-hero-' + (market === 'ES' ? 'ES-' : '') + '3840x400.jpg' : null"
	[imageMobile]="market ? 'assets/hero/HP-hero-' + (market === 'ES' ? 'ES-' : '') + '768x180.jpg' : null"
></app-hero>
<section class="container-xxl mh-500">
	@if (filteredLeasysAuctions || filteredMultiAuctions || filteredOtherAuctions) {
		@let allAuctions = filteredLeasysAuctions.concat(filteredMultiAuctions).concat(filteredOtherAuctions);
		<aside class="px-3 pt-3 pt-lg-5">
			<ng-template #cancelSearch>
				<a
					href="#"
					class="ck-link mt-2 mt-lg-0 ps-0 ps-lg-3 d-block d-lg-inline"
					(click)="$event.preventDefault(); resetSearch()"
				>
					{{ "auction.search.cancelSearch" | translate }}
				</a>
			</ng-template>
			<!-- Not showing auction search on DE and
			when there are no auctions (before searching: if I search, I can get an empty response) -->
			@if ((previousSearchValue || allAuctions.length) && market && market !== "DE") {
				<div class="text-lg-center border-bottom-gray pb-3">
					<h3 class="text-blue text-lg pb-3 fw-bold">{{ "auction.search.searchTitle" | translate }}</h3>
					<div class="searchField d-flex d-lg-inline-flex border bg-white">
						<input
							type="text"
							class="border-0 px-3 py-2 flex-grow-1 focus-ring"
							#searchInput
							(keyup.enter)="search(searchInput.value)"
							[placeholder]="'auction.search.searchPlaceholder' | translate"
						/>
						<!-- class="defaultInput" -->
						<button
							class="btn btn-transparent btn-ico btn-ico-search-after focus-ring"
							(click)="search(searchInput.value)"
						></button>
					</div>
					@if (previousSearchValue && !allAuctions.length) {
						<div class="pt-3">
							<strong class="text-blue text-xl"> {{ "auction.search.noSearchResults" | translate }}</strong>
							<ng-container *ngTemplateOutlet="cancelSearch"></ng-container>
						</div>
					}
				</div>
			}
			@if (previousSearchValue) {
				@if (allAuctions.length) {
					<div class="pt-3">
						<span
							class="text-blue"
							[innerHTML]="'auction.search.weFoundX' | translate: { searchString: previousSearchValue }"
						></span>
						<ng-container *ngTemplateOutlet="cancelSearch"></ng-container>
					</div>
				}
			} @else {
				@if (!allAuctions.length) {
					<div class="pt-5 text-center">
						<span class="text-blue text-xl"> {{ "auction.search.noAuctions" | translate }}</span>
					</div>
				}
			}
		</aside>
		@if (allAuctions.length) {
			@if (!previousSearchValue) {
				<main class="auction-topbar mb-2 pt-3">
					<div class="auction-topbar-left">
						<span class="top-label"> {{ runningCount }} {{ "auctions.running" | translate }}</span>
						<span class="separator">|</span>
						<span class="top-label"> {{ scheduledCount }} {{ "auctions.scheduled" | translate }}</span>
					</div>
				</main>
			}

			@for (auction of allAuctions; track auction.idAuction) {
				<app-auction-card
					[auction]="auction"
					[randomVehicles]="randomVehicles"
					[showAuctionType]="showAuctionType"
				>
				</app-auction-card>
			}
		}
	} @else {
		<div class="pt-5 text-center">
			<span class="text-blue text-xl"> {{ "auction.retrievingAuctions" | translate }}</span>
		</div>
	}
</section>
